import { Grid } from "@mui/material";
import { useTranslation } from "react-i18next";
import { numberWithCommas } from "../../../../utils/utility";

//import images and icons
import { InfoCircle } from "iconsax-react";

function IntFlightPriceDetails({ intFlightInformation, oldDetails, intFlightDetails }) {
    //general variables
    const { t } = useTranslation();

    return (
        <Grid className="int-flight-details-modal__prices" container item xs={12} rowGap={{ xs: 1, md: 2 }}>
            <Grid container item xs={12} columnGap={2}>
                <span>{t("Price.Price Details")}</span>
                {oldDetails?.fares?.total_price !== intFlightDetails?.fares?.total_price && (
                    <span className="int-flight-details-modal__warning">
                        <InfoCircle color="var(--golden-color)" /> {t("Toast Messages.Ticket Price Update")}
                    </span>
                )}
            </Grid>

            <Grid className="int-flight-details-modal__prices-details" container item xs={12} rowGap={1}>
                {intFlightInformation?.personCounter.adult > 0 && (
                    <Grid container item xs={12} justifyContent="space-between">
                        <span>
                            {intFlightInformation.personCounter.adult} {t("adult")}:{" "}
                        </span>
                        <Grid container item xs="auto" columnGap={2}>
                            {oldDetails?.fares?.adult.total_price !== intFlightDetails?.fares?.adult?.total_price && (
                                <span className="int-flight-details-modal__old-price">
                                    {numberWithCommas(oldDetails?.fares?.adult.total_price)} {t("currency")}
                                </span>
                            )}
                            <span>
                                {numberWithCommas(intFlightDetails?.fares?.adult?.total_price)} {t("currency")}
                            </span>
                        </Grid>
                    </Grid>
                )}
                
                {intFlightInformation?.personCounter.child > 0 && (
                    <Grid container item xs={12} justifyContent="space-between">
                        <span>
                            {intFlightInformation.personCounter.child} {t("child")}:{" "}
                        </span>
                        <Grid container item xs="auto" columnGap={2}>
                            {oldDetails?.fares?.child.total_price !== intFlightDetails?.fares?.child?.total_price && (
                                <span className="int-flight-details-modal__old-price">
                                    {numberWithCommas(oldDetails?.fares?.child.total_price)} {t("currency")}
                                </span>
                            )}
                            <span>
                                {numberWithCommas(intFlightDetails?.fares?.child?.total_price)} {t("currency")}
                            </span>
                        </Grid>
                    </Grid>
                )}

                {intFlightInformation?.personCounter.infant > 0 && (
                    <Grid container item xs={12} justifyContent="space-between">
                        <span>
                            {intFlightInformation.personCounter.infant} {t("infant")}:{" "}
                        </span>
                        <Grid container item xs="auto" columnGap={2}>
                            {oldDetails?.fares?.infant.total_price !== intFlightDetails?.fares?.infant?.total_price && (
                                <span className="int-flight-details-modal__old-price">
                                    {numberWithCommas(oldDetails?.fares?.infant.total_price)} {t("currency")}
                                </span>
                            )}
                            <span>
                                {numberWithCommas(intFlightDetails?.fares?.infant?.total_price)} {t("currency")}
                            </span>
                        </Grid>
                    </Grid>
                )}
            </Grid>
        </Grid>
    );
}

export default IntFlightPriceDetails;
